
/* injects from baggage-loader */

angular.module("siter.io").controller("DashboardLessons", [
  "$scope", "$rootScope", "$state", "$timeout", "Site", "Modal", "Template", "$location", "Section", "Widget", "Notification", "Lesson",
  ($scope, $rootScope, $state, $timeout, Site, Modal, Template, $location, Section, Widget, Notification, Lesson) => {

    if (window.justclick.currentUser.role === "client") {
      $location.path('/404');
    }

    $rootScope.site = {};

    $scope.state = $state;
    $scope.currentState = $state.current.name;
    $scope.tagobject = {tagName: ""};
    $scope.scrollDisabled = false;
    $scope.lessons = [];
    $scope.getHomePagePath = (pages) => {
      if (pages.length === 0) {
        return false;
      }

      const homePage = _.filter(pages, {
        home: true
      });

      return homePage[0].path;
    };

    $rootScope.refreshLessonTemplates = () => {
      $scope.LessonsLoading = true;
      Template.getLessonTemplates().then((lessons) => {
        $scope.Lessons = lessons;
        $scope.LessonsCount = lessons.length;
        $scope.LessonsLoading = false;
      });
    };

    const refreshLessonTags = () => {
      Template.getLessonUserCategories().then((tags) => {
        $scope.LessonTemplatesTags = tags;
      });
    };

    $scope.treeLessonOptions = {
      dropped: (e) => {
        $timeout(() => {
          Template.sortLessonCategories($scope.LessonTemplatesTags).then((tags) => {
            $scope.LessonTemplatesTags = tags;
          });
        });
      }
    };
    $scope.LessonSectionsLoading = true;
    $scope.removeLessonTemplate = (collection, form) => {
      const findedForm = _.filter(collection, { id: form.id });
      const index = collection.indexOf(findedForm[0]);

      $rootScope.alertDialog({
        title: "Deleting a lesson template",
        text: "Are you sure you want to delete this lesson template?",
        accept_text: "Yes",
        cancel_text: "Cancel",
        accept: () => {
          Lesson.remove(form.id).then(() => {
            return collection.splice(index, 1);
          });
        }
      });
    };
    $scope.saveLessonTemplate = (template) => {
      Lesson.update(template);
    };

    const listener3 = $rootScope.$on("lesson_form:created", (e, newLesson, template) => {
      if (template === null) {
        template = false;
      }
      if (template) {
        template.childs.push(newLesson);
      } else {
        $scope.Lessons.push(newLesson);
      }
      refreshLessonTags();
    });

    const listener4 = $rootScope.$on("lesson_form:updated", (e, newLesson, template) => {
      if (template === null) {
        template = false;
      }
      refreshLessonTags();
    });

    refreshLessonTags();

    $rootScope.refreshLessonTemplates();
    $scope.$on("$destroy", () => {
      listener3();
      listener4();
    });

    $scope.newLessonTemplate = Modal.newLessonTemplate;
    $scope.editLessonTemplate = Modal.editLessonTemplate;
  }
]);



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboardLessons.controller.js